import { render, staticRenderFns } from "./RelationListItemItem.vue?vue&type=template&id=18f9160e&scoped=true"
import script from "./RelationListItemItem.vue?vue&type=script&lang=js"
export * from "./RelationListItemItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f9160e",
  null
  
)

export default component.exports